/*
 * @Author: your name
 * @Date: 2022-04-26 11:40:52
 * @LastEditTime: 2024-12-04 17:03:54
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ts-react-vite_or_webpack/src/containers/shared/App/index.tsx
 */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import loadable from '@loadable/component';
import { Routes, Route } from 'react-router-dom';

import styles from './index.module.scss';
// import PageLoading from '@components/PageLoading';
import Provider from './Provider';
import HashRouter from './HashRouter';
import history from './ht';
import { getLocaleLoader } from '@locales/loader';
import '@/assets/font/iconfont.css';
import '@/assets/font-color/iconfont.css';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import '@/assets/font-new-aigroup/iconfont.css';
import '@/assets/font-origin/iconfont.css';
import loggerInit from '@utils/logger';
import currentEnv from '../../config';

const loadableOptions = {};
const Home = loadable(() => import('@containers/home'), loadableOptions);
const PrivacyAgreement = loadable(() => import('@containers/privacyAgreement/index'), loadableOptions);
const ExperiencePlan = loadable(() => import('@containers/experiencePlan'), loadableOptions);
const SubScription = loadable(() => import('@containers/subscriptions'), loadableOptions);
const PawpalPrivacy = loadable(() => import('@containers/pawpalPrivacy/index'), loadableOptions);
const AppWrapper: React.FC<ChildrenNode> = ({ children }) => (
    <div className={styles.appWrapper}>{children}</div>
);

function App() {
    let targetLocale: any = navigator.userAgent.match(/Yachlang\/(en-US|zh-CN)/);
    if (!targetLocale) targetLocale = 'zh-CN';
    else targetLocale = targetLocale[2];

    const [antdLocaleData, setAntdLocaleData] = useState(null);

    useLayoutEffect(() => {
        getLocaleLoader(targetLocale).then((res) => {
            setAntdLocaleData(res);
        });
    }, []);

    /**
     * @description: 设置rem的值
     * @param {number} baseSize  基准像素值，即设计稿中的1rem等于多少px
     * @param {number} designWidth  设计稿的宽度
     * @return {void}
     */
    const setRemUnit = () => {
        const baseSize = 10; // 基准像素值，即设计稿中的1rem等于多少px
        const designWidth = 375; // 设计稿的宽度
        const clientWidth = document.documentElement.clientWidth || window.innerWidth;

        if (clientWidth >= designWidth) {
            document.documentElement.style.fontSize = `${baseSize}px`;
        } else {
            document.documentElement.style.fontSize = `${(clientWidth / designWidth) * baseSize}px`;
        }
    };

    useEffect(() => {
        setRemUnit();
        const APP_ENV = currentEnv?.VITE_APP_ENV || process.env.VITE_APP_ENV;
        loggerInit({ env: APP_ENV, talId: '' })
        window.addEventListener('resize', setRemUnit);
        return () => {
            window.removeEventListener('resize', setRemUnit);
        };
    }, []);

    return (
        <div style={{ height: '100vh' }}>
            <Provider>
                <AppWrapper>
                    <HashRouter history={history}>
                        <Routes>
                            <Route
                                path="/"
                                element={
                                    <ConfigProvider locale={targetLocale === 'zh-CN' ? zhCN : enUS}>
                                        <Home lang={antdLocaleData} />{' '}
                                    </ConfigProvider>
                                }
                            />
                            <Route
                                path="/privacyAgreement"
                                element={<PrivacyAgreement lang={antdLocaleData} />}
                            />
                            <Route
                                path="/subscriptions"
                                element={<SubScription lang={antdLocaleData} />}
                            />
                            <Route
                                path="/experiencePlan"
                                element={<ExperiencePlan lang={antdLocaleData} />}
                            />
                            <Route
                                path="/pawpalPrivacy"
                                element={<PawpalPrivacy lang={antdLocaleData} />}
                            />
                        </Routes>
                    </HashRouter>
                </AppWrapper>
            </Provider>
        </div>
    );
}

export default App;
